export const LOGIN_TOKEN: string = "login_token";
export const ADMIN_LOGIN_TOKEN: string = "admin_login_token";
export const SESS_EXPIRED: string = "session_expired";
export const INTERNAL_ERR: string = "internal_error";
export const DEL_SUCCESS: string = "del_success";

export const ALMSG_SESS_EXPIRED: string = "Sessione scaduta";
export const ALMSG_UNAUTHORIZED_OP: string = "Operazione non autorizzata";
export const ALMSG_INTERNAL_ERR: string =
  "Errore interno: riprova o contatta l'assistenza";
export const ALMSG_BADREQUEST_ERR: string =
  "Richiesta non valida: formato scorretto!";

export const ALMSG_ERR_CREDENTIALS: string = "Credenziali errate";
